// extracted by mini-css-extract-plugin
var _1 = "CheckboxSkeleton-moduleCheckboxSkeleton__O8wIl";
var _2 = "CheckboxSkeleton-moduleicon___XS5m";
var _3 = "CheckboxSkeleton-moduleskeleton__BGo5F Skeleton-moduleSkeleton__Mlrfv";
var _4 = "CheckboxSkeleton-moduletext__HcNFZ";
export { _1 as "CheckboxSkeleton", _2 as "icon", _3 as "skeleton", _4 as "text" }
